// extracted by mini-css-extract-plugin
export default {"navbar":"NavButtons_navbar__oI9hp"};